import * as React from 'react';
var TreeSelectContext = /*#__PURE__*/React.createContext(null);
export default TreeSelectContext;